/* global gtag */
export function gaTrackEvent(name, data) {
    try {
        gtag('event', name, data);
    } catch (_) {}
}

export function gaTrackCategoryEvent(category) {
    return (name, value) =>
        gaTrackEvent(name, {
            event_category: category,
            value
        });
}

/* global gtag */
export function gaGrantConsent() {
    try {
        gtag('consent', 'update', {
            ad_storage: 'granted',
            ad_user_data: 'granted',
            ad_personalization: 'granted',
            analytics_storage: 'granted'
        });
    } catch (_) {}
}
